module.exports = __webpack_public_path__ + "img/filter-icon.147e57bf.svg";